import React from 'react';
import PurchaseHistory from './PurchaseHistory';

const SubscriptionPackages = ( {isPurchaseHistory,SubsFunc,subsDuration,purchaseHistoryHandler, purchaseHistoryGoBackHandler } ) => {

    const PackageSelectHandler = (event, type) => {
        SubsFunc(event, type);
    };

    const purchaseHistoryHandlerInner = () => {
        purchaseHistoryHandler();
    };

    // const purchaseHistoryGoBackHandlerInner = () => {
    //     purchaseHistoryGoBackHandler();
    // };

    return(
        <>
            { !isPurchaseHistory ? (<div className='row'>
                          <div 
                          className="col-md-6" 
                          onClick={(event)=>PackageSelectHandler(event,'month')}
                          // data-toggle="modal"
                          // data-target="#stripeModal"
                          >
                            <div className={subsDuration === 'month' ? ' hp-subs-leftbox hp-subs-bg' : ' hp-subs-leftbox'}>
                              <p className='subs-pckg-name'>Monthly Package</p>
                              <h1><span className='subs-pckg-dsign'>$</span>4</h1>
                              <p className="subs-pckg-dtnewline">/month</p>                              
                            </div>
                          </div>
                          <div 
                          className="col-md-6" 
                          onClick={(event)=>PackageSelectHandler(event,'year')}  
                          // data-toggle="modal"
                          // data-target="#stripeModal"
                          >
                            <div className={subsDuration === 'year' ?  'hp-subs-leftbox hp-subs-bg' :' hp-subs-leftbox'  } >
                              <p className='subs-pckg-name'>Yearly Package</p>
                              <h1><span className='subs-pckg-dsign'>$</span>40<span className='subs-pckg-durationInline' >/year</span></h1>
                              <p className="subs-pckg-durationtag">*Saves 17%</p>
                            </div>
                          </div>
                          <div className='col-md-12 hp-subs-discount text-center'>
                            <div className='row'>
                              <div className='col-md-6 '>
                                {/* <button disabled className="hp-subs-discount-btn">Discount Code</button> */}
                              </div>
                              <div className='col-md-6 '>
                                <button  className="hp-subs-discount-btn" onClick={purchaseHistoryHandlerInner}>Purchase History</button>
                              </div>
                            </div>
                          </div> 
                        </div>):
                        (
                          <PurchaseHistory goBack={purchaseHistoryGoBackHandler} isPurchaseHistory={isPurchaseHistory} />
                        )}
        </>
    );
};

export default SubscriptionPackages;